import React from 'react'

import { SearchDropdownListItem } from '../index'

import type { SearchDropdownSectionProps } from '../../../../types/SearchDropdown'

import './search-dropdown-section.scss'

export const SearchDropdownSection = ({
  sectionTitle,
  warningText,
  searchedItems,
  searchedTerm,
  trigger,
  isAisles,
  noHighlighted,
  updateSearchBar,
  hiddenVisibility,
}: SearchDropdownSectionProps) => {
  if (hiddenVisibility) {
    return null
  }

  const haveSearchedItems = searchedItems && searchedItems?.length > 0

  return (
    <div className="search-dropdown-list-item">
      <h1>{sectionTitle}</h1>
      {warningText && !haveSearchedItems ? (
        <div className="search-dropdown-list-item-warning">
          <p>{warningText}</p>
        </div>
      ) : (
        <SearchDropdownListItem
          isAisles={isAisles}
          searchedItems={searchedItems?.slice(0, 5)}
          trigger={trigger}
          searchedTerm={searchedTerm}
          noHighlighted={noHighlighted}
          updateSearchBar={updateSearchBar}
          sectionTitle={sectionTitle}
        />
      )}
    </div>
  )
}
